import React, { createContext } from 'react';
import { useAccordion } from '../hooks/use-accordion';
export var AccordionContext = /*#__PURE__*/createContext({
  ref: {
    current: null
  },
  state: {},
  isOpen: function isOpen() {
    return false;
  },
  onToggle: function onToggle() {
    return null;
  }
});

var AccordionProvider = function AccordionProvider(_ref) {
  var children = _ref.children,
      _ref$openOnMount = _ref.openOnMount,
      openOnMount = _ref$openOnMount === void 0 ? false : _ref$openOnMount,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? openOnMount : _ref$open;

  var _useAccordion = useAccordion({
    openOnMount: openOnMount,
    open: open
  }),
      ref = _useAccordion.ref,
      state = _useAccordion.state,
      isOpen = _useAccordion.isOpen,
      handleToggle = _useAccordion.handleToggle;

  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: {
      isOpen: isOpen,
      onToggle: handleToggle,
      ref: ref,
      state: state
    }
  }, children);
};

export default AccordionProvider;